import { Box, Flex, Typography } from '@creditas-ui/react';
import React, { forwardRef, useRef, useState } from 'react';
import { IconButton } from '../IconButton';
import useOutsideClick from './hooks/useOutsideClick';
import { OptionsContainer, Option, SelectButton } from './Select.styles';
var Select = forwardRef(function (_a, ref) {
    var options = _a.options, selectedOption = _a.selectedOption, onChangeOption = _a.onChangeOption, _b = _a.maxWidth, maxWidth = _b === void 0 ? 300 : _b, width = _a.width, displayText = _a.displayText, _c = _a.withIcon, withIcon = _c === void 0 ? true : _c;
    var optionsRef = useRef(null);
    var _d = useState(false), showOptions = _d[0], setShowOptions = _d[1];
    var selected = options.find(function (option) { return option.value === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value); });
    var handleOptionsSelect = function (option) {
        setShowOptions(false);
        onChangeOption(option);
    };
    useOutsideClick({
        callback: function () { return setShowOptions(false); },
        ref: optionsRef,
    });
    return (React.createElement(Box, null,
        React.createElement(SelectButton, { ref: ref, onClick: function () { return setShowOptions(true); } },
            React.createElement(Flex, { flexDirection: "row", alignItems: "center" },
                React.createElement(Typography, { variant: "bodySmRegular", color: "neutral.100" }, displayText !== null && displayText !== void 0 ? displayText : selected === null || selected === void 0 ? void 0 : selected.text),
                withIcon && React.createElement(IconButton, { "data-testid": "icon-button", as: "div" }))),
        showOptions ? (React.createElement(OptionsContainer, { maxWidth: maxWidth, width: width, ref: optionsRef }, options.map(function (option, index) { return (React.createElement(Option, { value: option.value, key: option.text, onClick: function () { return handleOptionsSelect(options[index]); }, isSelected: (selected === null || selected === void 0 ? void 0 : selected.value) === options[index].value, role: "option" }, option.text)); }))) : null));
});
export default Select;
//# sourceMappingURL=Select.js.map